"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.List = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../TypeList/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var List = exports.List = (0, _styledComponents["default"])(_index.TypeList).attrs({
  condensedAll: true,
  listStyleReset: true,
  forwardedAs: 'dl'
}).withConfig({
  displayName: "List",
  componentId: "sc-bff34i-0"
})(["", ";@media (max-width:", "){display:flex;inline-size:100%;}"], function (props) {
  return props.$flex && (0, _styledComponents.css)(["@media (max-width:", "){justify-content:space-between;}"], _encoreFoundation.screenXsMax);
}, _encoreFoundation.screenXsMax);
var _default = exports["default"] = List;